var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _require = require('./config'),
    defaultArgs = _require.defaultArgs,
    baseOptions = _require.baseOptions;

var _require2 = require('./utils/log'),
    setLogging = _require2.setLogging,
    setCustomLogger = _require2.setCustomLogger,
    log = _require2.log;

var parseProgress = require('./utils/parseProgress');

var parseArgs = require('./utils/parseArgs');

var _require3 = require('./node'),
    defaultOptions = _require3.defaultOptions,
    getCreateFFmpegCore = _require3.getCreateFFmpegCore;

var _require4 = require('../package.json'),
    version = _require4.version;

var NO_LOAD = Error('ffmpeg.wasm is not ready, make sure you have completed load().');

module.exports = function () {
  var _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _baseOptions$defaultO = _objectSpread(_objectSpread(_objectSpread({}, baseOptions), defaultOptions), _options),
      logging = _baseOptions$defaultO.log,
      logger = _baseOptions$defaultO.logger,
      optProgress = _baseOptions$defaultO.progress,
      options = _objectWithoutProperties(_baseOptions$defaultO, ["log", "logger", "progress"]);

  var Core = null;
  var ffmpeg = null;
  var runResolve = null;
  var running = false;
  var progress = optProgress;

  var detectCompletion = function detectCompletion(message) {
    if (message === 'FFMPEG_END' && runResolve !== null) {
      runResolve();
      runResolve = null;
      running = false;
    }
  };

  var parseMessage = function parseMessage(_ref) {
    var type = _ref.type,
        message = _ref.message;
    log(type, message);
    parseProgress(message, progress);
    detectCompletion(message);
  };
  /*
   * Load ffmpeg.wasm-core script.
   * In browser environment, the ffmpeg.wasm-core script is fetch from
   * CDN and can be assign to a local path by assigning `corePath`.
   * In node environment, we use dynamic require and the default `corePath`
   * is `$ffmpeg/core`.
   *
   * Typically the load() func might take few seconds to minutes to complete,
   * better to do it as early as possible.
   *
   */


  var load = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$getCreateFFmpe, createFFmpegCore, corePath, workerPath, wasmPath;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log('info', 'load ffmpeg-core');

              if (!(Core === null)) {
                _context.next = 17;
                break;
              }

              log('info', 'loading ffmpeg-core');
              /*
               * In node environment, all paths are undefined as there
               * is no need to set them.
               */

              _context.next = 5;
              return getCreateFFmpegCore(options);

            case 5:
              _yield$getCreateFFmpe = _context.sent;
              createFFmpegCore = _yield$getCreateFFmpe.createFFmpegCore;
              corePath = _yield$getCreateFFmpe.corePath;
              workerPath = _yield$getCreateFFmpe.workerPath;
              wasmPath = _yield$getCreateFFmpe.wasmPath;
              _context.next = 12;
              return createFFmpegCore({
                /*
                 * Assign mainScriptUrlOrBlob fixes chrome extension web worker issue
                 * as there is no document.currentScript in the context of content_scripts
                 */
                mainScriptUrlOrBlob: corePath,
                printErr: function printErr(message) {
                  return parseMessage({
                    type: 'fferr',
                    message: message
                  });
                },
                print: function print(message) {
                  return parseMessage({
                    type: 'ffout',
                    message: message
                  });
                },

                /*
                 * locateFile overrides paths of files that is loaded by main script (ffmpeg-core.js).
                 * It is critical for browser environment and we override both wasm and worker paths
                 * as we are using blob URL instead of original URL to avoid cross origin issues.
                 */
                locateFile: function locateFile(path, prefix) {
                  if (typeof window !== 'undefined') {
                    if (typeof wasmPath !== 'undefined' && path.endsWith('ffmpeg-core.wasm')) {
                      return wasmPath;
                    }

                    if (typeof workerPath !== 'undefined' && path.endsWith('ffmpeg-core.worker.js')) {
                      return workerPath;
                    }
                  }

                  return prefix + path;
                }
              });

            case 12:
              Core = _context.sent;
              ffmpeg = Core.cwrap('proxy_main', 'number', ['number', 'number']);
              log('info', 'ffmpeg-core loaded');
              _context.next = 18;
              break;

            case 17:
              throw Error('ffmpeg.wasm was loaded, you should not load it again, use ffmpeg.isLoaded() to check next time.');

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function load() {
      return _ref2.apply(this, arguments);
    };
  }();
  /*
   * Determine whether the Core is loaded.
   */


  var isLoaded = function isLoaded() {
    return Core !== null;
  };
  /*
   * Run ffmpeg command.
   * This is the major function in ffmpeg.wasm, you can just imagine it
   * as ffmpeg native cli and what you need to pass is the same.
   *
   * For example, you can convert native command below:
   *
   * ```
   * $ ffmpeg -i video.avi -c:v libx264 video.mp4
   * ```
   *
   * To
   *
   * ```
   * await ffmpeg.run('-i', 'video.avi', '-c:v', 'libx264', 'video.mp4');
   * ```
   *
   */


  var run = function run() {
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    log('info', "run ffmpeg command: ".concat(_args.join(' ')));

    if (Core === null) {
      throw NO_LOAD;
    } else if (running) {
      throw Error('ffmpeg.wasm can only run one command at a time');
    } else {
      running = true;
      return new Promise(function (resolve) {
        var args = [].concat(_toConsumableArray(defaultArgs), _args).filter(function (s) {
          return s.length !== 0;
        });
        runResolve = resolve;
        ffmpeg.apply(void 0, _toConsumableArray(parseArgs(Core, args)));
      });
    }
  };
  /*
   * Run FS operations.
   * For input/output file of ffmpeg.wasm, it is required to save them to MEMFS
   * first so that ffmpeg.wasm is able to consume them. Here we rely on the FS
   * methods provided by Emscripten.
   *
   * Common methods to use are:
   * ffmpeg.FS('writeFile', 'video.avi', new Uint8Array(...)): writeFile writes
   * data to MEMFS. You need to use Uint8Array for binary data.
   * ffmpeg.FS('readFile', 'video.mp4'): readFile from MEMFS.
   * ffmpeg.FS('unlink', 'video.map'): delete file from MEMFS.
   *
   * For more info, check https://emscripten.org/docs/api_reference/Filesystem-API.html
   *
   */


  var FS = function FS(method) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    log('info', "run FS.".concat(method, " ").concat(args.map(function (arg) {
      return typeof arg === 'string' ? arg : "<".concat(arg.length, " bytes binary file>");
    }).join(' ')));

    if (Core === null) {
      throw NO_LOAD;
    } else {
      var ret = null;

      try {
        var _Core$FS;

        ret = (_Core$FS = Core.FS)[method].apply(_Core$FS, args);
      } catch (e) {
        if (method === 'readdir') {
          throw Error("ffmpeg.FS('readdir', '".concat(args[0], "') error. Check if the path exists, ex: ffmpeg.FS('readdir', '/')"));
        } else if (method === 'readFile') {
          throw Error("ffmpeg.FS('readFile', '".concat(args[0], "') error. Check if the path exists"));
        } else {
          throw Error('Oops, something went wrong in FS operation.');
        }
      }

      return ret;
    }
  };

  var setProgress = function setProgress(_progress) {
    progress = _progress;
  };

  var setLogger = function setLogger(_logger) {
    setCustomLogger(_logger);
  };

  setLogging(logging);
  setCustomLogger(logger);
  log('info', "use ffmpeg.wasm v".concat(version));
  return {
    setProgress: setProgress,
    setLogger: setLogger,
    setLogging: setLogging,
    load: load,
    isLoaded: isLoaded,
    run: run,
    FS: FS
  };
};